@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(554_570_848)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

@delegate:ResourceContentHash(1_097_382_560)
internal val Res.string.application_type_android_runtime: StringResource by lazy {
      StringResource("string:application_type_android_runtime", "application_type_android_runtime", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 35, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 68),
      ))
    }

@delegate:ResourceContentHash(-1_225_694_912)
internal val Res.string.application_type_linux_init_x64: StringResource by lazy {
      StringResource("string:application_type_linux_init_x64", "application_type_linux_init_x64", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 104, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104, 55),
      ))
    }

@delegate:ResourceContentHash(-1_862_326_304)
internal val Res.string.application_type_linux_runtime_arm: StringResource by lazy {
      StringResource("string:application_type_linux_runtime_arm", "application_type_linux_runtime_arm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 160, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 160, 66),
      ))
    }

@delegate:ResourceContentHash(2_012_232_384)
internal val Res.string.application_type_linux_runtime_x64: StringResource by lazy {
      StringResource("string:application_type_linux_runtime_x64", "application_type_linux_runtime_x64", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 227, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227, 66),
      ))
    }

@delegate:ResourceContentHash(-1_238_941_292)
internal val Res.string.application_type_www_campaign: StringResource by lazy {
      StringResource("string:application_type_www_campaign", "application_type_www_campaign", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 294, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294, 49),
      ))
    }

@delegate:ResourceContentHash(-1_410_373_877)
internal val Res.string.application_type_www_wheel: StringResource by lazy {
      StringResource("string:application_type_www_wheel", "application_type_www_wheel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 344, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344, 42),
      ))
    }

@delegate:ResourceContentHash(1_015_173_402)
internal val Res.string.applications: StringResource by lazy {
      StringResource("string:applications", "applications", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 395, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 36),
      ))
    }

@delegate:ResourceContentHash(-718_983_015)
internal val Res.string.apps: StringResource by lazy {
      StringResource("string:apps", "apps", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 432, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 424, 20),
      ))
    }

@delegate:ResourceContentHash(2_075_806_342)
internal val Res.string.campaigns: StringResource by lazy {
      StringResource("string:campaigns", "campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 461, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 445, 29),
      ))
    }

@delegate:ResourceContentHash(-526_566_499)
internal val Res.string.companies: StringResource by lazy {
      StringResource("string:companies", "companies", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 491, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 475, 29),
      ))
    }

@delegate:ResourceContentHash(1_031_192_483)
internal val Res.string.devices: StringResource by lazy {
      StringResource("string:devices", "devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 517, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 505, 27),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.dialog_cancel: StringResource by lazy {
      StringResource("string:dialog_cancel", "dialog_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 545, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 533, 29),
      ))
    }

@delegate:ResourceContentHash(1_193_881_162)
internal val Res.string.dialog_close: StringResource by lazy {
      StringResource("string:dialog_close", "dialog_close", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 579, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 563, 28),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.dialog_ok: StringResource by lazy {
      StringResource("string:dialog_ok", "dialog_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 612, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 592, 21),
      ))
    }

@delegate:ResourceContentHash(-1_106_262_155)
internal val Res.string.dialog_open: StringResource by lazy {
      StringResource("string:dialog_open", "dialog_open", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 638, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 614, 27),
      ))
    }

@delegate:ResourceContentHash(83_189_163)
internal val Res.string.dow_fri: StringResource by lazy {
      StringResource("string:dow_fri", "dow_fri", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 693, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 669, 19),
      ))
    }

@delegate:ResourceContentHash(-1_356_026_652)
internal val Res.string.dow_friday: StringResource by lazy {
      StringResource("string:dow_friday", "dow_friday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 666, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 642, 26),
      ))
    }

@delegate:ResourceContentHash(83_198_065)
internal val Res.string.dow_mon: StringResource by lazy {
      StringResource("string:dow_mon", "dow_mon", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 748, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 716, 19),
      ))
    }

@delegate:ResourceContentHash(-653_690_920)
internal val Res.string.dow_monday: StringResource by lazy {
      StringResource("string:dow_monday", "dow_monday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 713, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 689, 26),
      ))
    }

@delegate:ResourceContentHash(82_624_385)
internal val Res.string.dow_sat: StringResource by lazy {
      StringResource("string:dow_sat", "dow_sat", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 797, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 769, 19),
      ))
    }

@delegate:ResourceContentHash(102_206_182)
internal val Res.string.dow_saturday: StringResource by lazy {
      StringResource("string:dow_saturday", "dow_saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 768, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 736, 32),
      ))
    }

@delegate:ResourceContentHash(83_430_255)
internal val Res.string.dow_sun: StringResource by lazy {
      StringResource("string:dow_sun", "dow_sun", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 848, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 816, 19),
      ))
    }

@delegate:ResourceContentHash(1_455_520_855)
internal val Res.string.dow_sunday: StringResource by lazy {
      StringResource("string:dow_sunday", "dow_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 817, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 789, 26),
      ))
    }

@delegate:ResourceContentHash(1_739_283_379)
internal val Res.string.dow_thu: StringResource by lazy {
      StringResource("string:dow_thu", "dow_thu", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 901, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 869, 19),
      ))
    }

@delegate:ResourceContentHash(342_964_421)
internal val Res.string.dow_thursday: StringResource by lazy {
      StringResource("string:dow_thursday", "dow_thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 868, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 836, 32),
      ))
    }

@delegate:ResourceContentHash(84_698_146)
internal val Res.string.dow_tue: StringResource by lazy {
      StringResource("string:dow_tue", "dow_tue", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 953, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 921, 19),
      ))
    }

@delegate:ResourceContentHash(335_842_571)
internal val Res.string.dow_tuesday: StringResource by lazy {
      StringResource("string:dow_tuesday", "dow_tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 925, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 889, 31),
      ))
    }

@delegate:ResourceContentHash(82_643_341)
internal val Res.string.dow_wed: StringResource by lazy {
      StringResource("string:dow_wed", "dow_wed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1007, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 975, 19),
      ))
    }

@delegate:ResourceContentHash(1_613_279_074)
internal val Res.string.dow_wednesday: StringResource by lazy {
      StringResource("string:dow_wednesday", "dow_wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 973, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 941, 33),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.empty: StringResource by lazy {
      StringResource("string:empty", "empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1027, 13),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 995, 13),
      ))
    }

@delegate:ResourceContentHash(-1_977_843_466)
internal val Res.string.locations: StringResource by lazy {
      StringResource("string:locations", "locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1041, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1009, 29),
      ))
    }

@delegate:ResourceContentHash(509_354_072)
internal val Res.string.media: StringResource by lazy {
      StringResource("string:media", "media", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1071, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1039, 21),
      ))
    }

@delegate:ResourceContentHash(84_141_902)
internal val Res.string.month_apr: StringResource by lazy {
      StringResource("string:month_apr", "month_apr", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1093, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1061, 21),
      ))
    }

@delegate:ResourceContentHash(80_700_550)
internal val Res.string.month_aug: StringResource by lazy {
      StringResource("string:month_aug", "month_aug", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1115, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1083, 21),
      ))
    }

@delegate:ResourceContentHash(83_232_874)
internal val Res.string.month_dec: StringResource by lazy {
      StringResource("string:month_dec", "month_dec", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1137, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1105, 21),
      ))
    }

@delegate:ResourceContentHash(-1_725_944_460)
internal val Res.string.month_feb: StringResource by lazy {
      StringResource("string:month_feb", "month_feb", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1159, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1127, 21),
      ))
    }

@delegate:ResourceContentHash(82_675_815)
internal val Res.string.month_jan: StringResource by lazy {
      StringResource("string:month_jan", "month_jan", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1185, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1149, 21),
      ))
    }

@delegate:ResourceContentHash(82_674_573)
internal val Res.string.month_jul: StringResource by lazy {
      StringResource("string:month_jul", "month_jul", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1207, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1171, 21),
      ))
    }

@delegate:ResourceContentHash(82_379_548)
internal val Res.string.month_jun: StringResource by lazy {
      StringResource("string:month_jun", "month_jun", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1229, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1193, 21),
      ))
    }

@delegate:ResourceContentHash(-1_457_312_143)
internal val Res.string.month_mar: StringResource by lazy {
      StringResource("string:month_mar", "month_mar", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1251, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1215, 21),
      ))
    }

@delegate:ResourceContentHash(82_696_862)
internal val Res.string.month_may: StringResource by lazy {
      StringResource("string:month_may", "month_may", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1277, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1237, 21),
      ))
    }

@delegate:ResourceContentHash(82_707_957)
internal val Res.string.month_nov: StringResource by lazy {
      StringResource("string:month_nov", "month_nov", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1299, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1259, 21),
      ))
    }

@delegate:ResourceContentHash(82_351_455)
internal val Res.string.month_oct: StringResource by lazy {
      StringResource("string:month_oct", "month_oct", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1321, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1281, 21),
      ))
    }

@delegate:ResourceContentHash(84_445_514)
internal val Res.string.month_sep: StringResource by lazy {
      StringResource("string:month_sep", "month_sep", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1343, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1303, 21),
      ))
    }

@delegate:ResourceContentHash(-2_114_660_715)
internal val Res.string.moto: StringResource by lazy {
      StringResource("string:moto", "moto", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1365, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1325, 48),
      ))
    }

@delegate:ResourceContentHash(83_454_045)
internal val Res.string.no: StringResource by lazy {
      StringResource("string:no", "no", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1418, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1374, 14),
      ))
    }

@delegate:ResourceContentHash(-1_804_561_790)
internal val Res.string.string_ui_locations_detail_devices_empty: StringResource by lazy {
      StringResource("string:string_ui_locations_detail_devices_empty", "string_ui_locations_detail_devices_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1433, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1389, 92),
      ))
    }

@delegate:ResourceContentHash(-1_084_092_026)
internal val Res.string.ui_action_add: StringResource by lazy {
      StringResource("string:ui_action_add", "ui_action_add", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1522, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1482, 25),
      ))
    }

@delegate:ResourceContentHash(-251_236_139)
internal val Res.string.ui_action_change: StringResource by lazy {
      StringResource("string:ui_action_change", "ui_action_change", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1552, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1508, 32),
      ))
    }

@delegate:ResourceContentHash(881_315_651)
internal val Res.string.ui_action_delete: StringResource by lazy {
      StringResource("string:ui_action_delete", "ui_action_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1589, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1541, 32),
      ))
    }

@delegate:ResourceContentHash(546_863_784)
internal val Res.string.ui_action_view: StringResource by lazy {
      StringResource("string:ui_action_view", "ui_action_view", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1626, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 30),
      ))
    }

@delegate:ResourceContentHash(-9_383_764)
internal val Res.string.ui_app_instance_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_delete_confirm_message", "ui_app_instance_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1661, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1605, 121),
      ))
    }

@delegate:ResourceContentHash(-1_322_607_522)
internal val Res.string.ui_app_instance_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_delete_confirm_title", "ui_app_instance_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1799, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1727, 79),
      ))
    }

@delegate:ResourceContentHash(1_615_611_799)
internal val Res.string.ui_app_instance_detail_delete_failed: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_delete_failed", "ui_app_instance_detail_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1887, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1807, 84),
      ))
    }

@delegate:ResourceContentHash(-792_467_292)
internal val Res.string.ui_app_instance_detail_game_preview: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_game_preview", "ui_app_instance_detail_game_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1988, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1892, 59),
      ))
    }

@delegate:ResourceContentHash(1_975_836_314)
internal val Res.string.ui_app_instance_detail_gift: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_gift", "ui_app_instance_detail_gift", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2048, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1952, 43),
      ))
    }

@delegate:ResourceContentHash(1_949_870_957)
internal val Res.string.ui_app_instance_detail_rewards: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_rewards", "ui_app_instance_detail_rewards", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2161, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2069, 50),
      ))
    }

@delegate:ResourceContentHash(1_482_225_635)
internal val Res.string.ui_app_instance_detail_rewards_count: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_rewards_count", "ui_app_instance_detail_rewards_count", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2092, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1996, 72),
      ))
    }

@delegate:ResourceContentHash(422_147_543)
internal val Res.string.ui_app_instance_detail_splash_screen: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_splash_screen", "ui_app_instance_detail_splash_screen", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2212, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2120, 64),
      ))
    }

@delegate:ResourceContentHash(-1_862_449_975)
internal val Res.string.ui_app_instance_detail_touch_start: StringResource by lazy {
      StringResource("string:ui_app_instance_detail_touch_start", "ui_app_instance_detail_touch_start", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2277, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2185, 74),
      ))
    }

@delegate:ResourceContentHash(696_601_538)
internal val Res.string.ui_app_instance_edit_add_item_desc: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_add_item_desc", "ui_app_instance_edit_add_item_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2364, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2260, 54),
      ))
    }

@delegate:ResourceContentHash(-948_690_937)
internal val Res.string.ui_app_instance_edit_app_name: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_app_name", "ui_app_instance_edit_app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2423, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2315, 61),
      ))
    }

@delegate:ResourceContentHash(-1_740_470_138)
internal val Res.string.ui_app_instance_edit_background: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_background", "ui_app_instance_edit_background", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2485, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2377, 55),
      ))
    }

@delegate:ResourceContentHash(2_007_328_466)
internal val Res.string.ui_app_instance_edit_bg_color: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_bg_color", "ui_app_instance_edit_bg_color", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2537, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2433, 61),
      ))
    }

@delegate:ResourceContentHash(-1_997_082_069)
internal val Res.string.ui_app_instance_edit_btn_pick: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_btn_pick", "ui_app_instance_edit_btn_pick", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2595, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2495, 45),
      ))
    }

@delegate:ResourceContentHash(1_626_272_359)
internal val Res.string.ui_app_instance_edit_change_image: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_change_image", "ui_app_instance_edit_change_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2645, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2541, 57),
      ))
    }

@delegate:ResourceContentHash(-621_664_550)
internal val Res.string.ui_app_instance_edit_delete_desc: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_delete_desc", "ui_app_instance_edit_delete_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2707, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2599, 48),
      ))
    }

@delegate:ResourceContentHash(735_634_953)
internal val Res.string.ui_app_instance_edit_game_bg_image: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_game_bg_image", "ui_app_instance_edit_game_bg_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2760, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2648, 70),
      ))
    }

@delegate:ResourceContentHash(479_428_803)
internal val Res.string.ui_app_instance_edit_game_timeout: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_game_timeout", "ui_app_instance_edit_game_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2831, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2719, 65),
      ))
    }

@delegate:ResourceContentHash(164_586_306)
internal val Res.string.ui_app_instance_edit_general_config: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_general_config", "ui_app_instance_edit_general_config", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2897, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2785, 71),
      ))
    }

@delegate:ResourceContentHash(-575_136_246)
internal val Res.string.ui_app_instance_edit_icon: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_icon", "ui_app_instance_edit_icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2969, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2857, 41),
      ))
    }

@delegate:ResourceContentHash(767_539_796)
internal val Res.string.ui_app_instance_edit_items_icon_size: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_items_icon_size", "ui_app_instance_edit_items_icon_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3011, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2899, 64),
      ))
    }

@delegate:ResourceContentHash(679_740_309)
internal val Res.string.ui_app_instance_edit_items_icon_y: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_items_icon_y", "ui_app_instance_edit_items_icon_y", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3088, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2964, 85),
      ))
    }

@delegate:ResourceContentHash(566_149_535)
internal val Res.string.ui_app_instance_edit_items_text_size: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_items_text_size", "ui_app_instance_edit_items_text_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3178, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3050, 64),
      ))
    }

@delegate:ResourceContentHash(893_120_435)
internal val Res.string.ui_app_instance_edit_items_text_y: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_items_text_y", "ui_app_instance_edit_items_text_y", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3255, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3115, 85),
      ))
    }

@delegate:ResourceContentHash(200_228_713)
internal val Res.string.ui_app_instance_edit_label: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_label", "ui_app_instance_edit_label", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3349, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3201, 42),
      ))
    }

@delegate:ResourceContentHash(-2_094_567_269)
internal val Res.string.ui_app_instance_edit_landscape: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_landscape", "ui_app_instance_edit_landscape", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3392, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3244, 50),
      ))
    }

@delegate:ResourceContentHash(-890_312_753)
internal val Res.string.ui_app_instance_edit_marker_color: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_marker_color", "ui_app_instance_edit_marker_color", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3443, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3295, 57),
      ))
    }

@delegate:ResourceContentHash(835_527_142)
internal val Res.string.ui_app_instance_edit_new_item_template: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_new_item_template", "ui_app_instance_edit_new_item_template", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3501, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3353, 66),
      ))
    }

@delegate:ResourceContentHash(1_640_134_050)
internal val Res.string.ui_app_instance_edit_new_wheel_game: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_new_wheel_game", "ui_app_instance_edit_new_wheel_game", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3572, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3420, 63),
      ))
    }

@delegate:ResourceContentHash(789_435_372)
internal val Res.string.ui_app_instance_edit_no_image: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_no_image", "ui_app_instance_edit_no_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3644, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3484, 49),
      ))
    }

@delegate:ResourceContentHash(-502_164_138)
internal val Res.string.ui_app_instance_edit_none: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_none", "ui_app_instance_edit_none", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3698, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3534, 41),
      ))
    }

@delegate:ResourceContentHash(-1_587_823_040)
internal val Res.string.ui_app_instance_edit_portrait: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_portrait", "ui_app_instance_edit_portrait", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3740, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3576, 49),
      ))
    }

@delegate:ResourceContentHash(-50_291_935)
internal val Res.string.ui_app_instance_edit_result_timeout: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_result_timeout", "ui_app_instance_edit_result_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3790, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3626, 67),
      ))
    }

@delegate:ResourceContentHash(1_854_747_343)
internal val Res.string.ui_app_instance_edit_reward_visual: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_reward_visual", "ui_app_instance_edit_reward_visual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3862, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3694, 62),
      ))
    }

@delegate:ResourceContentHash(1_949_870_957)
internal val Res.string.ui_app_instance_edit_rewards_count: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_rewards_count", "ui_app_instance_edit_rewards_count", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3925, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3757, 54),
      ))
    }

@delegate:ResourceContentHash(-4_050_717)
internal val Res.string.ui_app_instance_edit_screen_orientation: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_screen_orientation", "ui_app_instance_edit_screen_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3980, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3812, 71),
      ))
    }

@delegate:ResourceContentHash(-1_116_330_497)
internal val Res.string.ui_app_instance_edit_select_image: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_select_image", "ui_app_instance_edit_select_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4056, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3884, 57),
      ))
    }

@delegate:ResourceContentHash(1_960_730_076)
internal val Res.string.ui_app_instance_edit_splash_image: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_splash_image", "ui_app_instance_edit_splash_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4118, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3942, 69),
      ))
    }

@delegate:ResourceContentHash(-1_289_057_369)
internal val Res.string.ui_app_instance_edit_splash_timeout: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_splash_timeout", "ui_app_instance_edit_splash_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4192, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4012, 67),
      ))
    }

@delegate:ResourceContentHash(-1_928_441_547)
internal val Res.string.ui_app_instance_edit_tab_preview: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_tab_preview", "ui_app_instance_edit_tab_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4276, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4080, 52),
      ))
    }

@delegate:ResourceContentHash(-2_124_233_988)
internal val Res.string.ui_app_instance_edit_text_color: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_text_color", "ui_app_instance_edit_text_color", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4329, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4133, 55),
      ))
    }

@delegate:ResourceContentHash(-1_163_350_568)
internal val Res.string.ui_app_instance_edit_theme_design: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_theme_design", "ui_app_instance_edit_theme_design", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4385, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4189, 61),
      ))
    }

@delegate:ResourceContentHash(1_151_649_994)
internal val Res.string.ui_app_instance_edit_timers_config: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_timers_config", "ui_app_instance_edit_timers_config", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4447, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4251, 70),
      ))
    }

@delegate:ResourceContentHash(-1_044_181_168)
internal val Res.string.ui_app_instance_edit_warn_min_sectors: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_warn_min_sectors", "ui_app_instance_edit_warn_min_sectors", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4518, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4322, 101),
      ))
    }

@delegate:ResourceContentHash(1_114_503_484)
internal val Res.string.ui_app_instance_edit_warn_name_empty: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_warn_name_empty", "ui_app_instance_edit_warn_name_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4612, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4424, 88),
      ))
    }

@delegate:ResourceContentHash(322_860_863)
internal val Res.string.ui_app_instance_edit_wheel_center_color: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_center_color", "ui_app_instance_edit_wheel_center_color", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4709, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4513, 71),
      ))
    }

@delegate:ResourceContentHash(-1_414_536)
internal val Res.string.ui_app_instance_edit_wheel_center_scale: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_center_scale", "ui_app_instance_edit_wheel_center_scale", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4781, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4585, 71),
      ))
    }

@delegate:ResourceContentHash(238_548_273)
internal val Res.string.ui_app_instance_edit_wheel_color: StringResource by lazy {
      StringResource("string:ui_app_instance_edit_wheel_color", "ui_app_instance_edit_wheel_color", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4861, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4657, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("application_type_android_runtime", Res.string.application_type_android_runtime)
  map.put("application_type_linux_init_x64", Res.string.application_type_linux_init_x64)
  map.put("application_type_linux_runtime_arm", Res.string.application_type_linux_runtime_arm)
  map.put("application_type_linux_runtime_x64", Res.string.application_type_linux_runtime_x64)
  map.put("application_type_www_campaign", Res.string.application_type_www_campaign)
  map.put("application_type_www_wheel", Res.string.application_type_www_wheel)
  map.put("applications", Res.string.applications)
  map.put("apps", Res.string.apps)
  map.put("campaigns", Res.string.campaigns)
  map.put("companies", Res.string.companies)
  map.put("devices", Res.string.devices)
  map.put("dialog_cancel", Res.string.dialog_cancel)
  map.put("dialog_close", Res.string.dialog_close)
  map.put("dialog_ok", Res.string.dialog_ok)
  map.put("dialog_open", Res.string.dialog_open)
  map.put("dow_fri", Res.string.dow_fri)
  map.put("dow_friday", Res.string.dow_friday)
  map.put("dow_mon", Res.string.dow_mon)
  map.put("dow_monday", Res.string.dow_monday)
  map.put("dow_sat", Res.string.dow_sat)
  map.put("dow_saturday", Res.string.dow_saturday)
  map.put("dow_sun", Res.string.dow_sun)
  map.put("dow_sunday", Res.string.dow_sunday)
  map.put("dow_thu", Res.string.dow_thu)
  map.put("dow_thursday", Res.string.dow_thursday)
  map.put("dow_tue", Res.string.dow_tue)
  map.put("dow_tuesday", Res.string.dow_tuesday)
  map.put("dow_wed", Res.string.dow_wed)
  map.put("dow_wednesday", Res.string.dow_wednesday)
  map.put("empty", Res.string.empty)
  map.put("locations", Res.string.locations)
  map.put("media", Res.string.media)
  map.put("month_apr", Res.string.month_apr)
  map.put("month_aug", Res.string.month_aug)
  map.put("month_dec", Res.string.month_dec)
  map.put("month_feb", Res.string.month_feb)
  map.put("month_jan", Res.string.month_jan)
  map.put("month_jul", Res.string.month_jul)
  map.put("month_jun", Res.string.month_jun)
  map.put("month_mar", Res.string.month_mar)
  map.put("month_may", Res.string.month_may)
  map.put("month_nov", Res.string.month_nov)
  map.put("month_oct", Res.string.month_oct)
  map.put("month_sep", Res.string.month_sep)
  map.put("moto", Res.string.moto)
  map.put("no", Res.string.no)
  map.put("string_ui_locations_detail_devices_empty", Res.string.string_ui_locations_detail_devices_empty)
  map.put("ui_action_add", Res.string.ui_action_add)
  map.put("ui_action_change", Res.string.ui_action_change)
  map.put("ui_action_delete", Res.string.ui_action_delete)
  map.put("ui_action_view", Res.string.ui_action_view)
  map.put("ui_app_instance_detail_delete_confirm_message", Res.string.ui_app_instance_detail_delete_confirm_message)
  map.put("ui_app_instance_detail_delete_confirm_title", Res.string.ui_app_instance_detail_delete_confirm_title)
  map.put("ui_app_instance_detail_delete_failed", Res.string.ui_app_instance_detail_delete_failed)
  map.put("ui_app_instance_detail_game_preview", Res.string.ui_app_instance_detail_game_preview)
  map.put("ui_app_instance_detail_gift", Res.string.ui_app_instance_detail_gift)
  map.put("ui_app_instance_detail_rewards", Res.string.ui_app_instance_detail_rewards)
  map.put("ui_app_instance_detail_rewards_count", Res.string.ui_app_instance_detail_rewards_count)
  map.put("ui_app_instance_detail_splash_screen", Res.string.ui_app_instance_detail_splash_screen)
  map.put("ui_app_instance_detail_touch_start", Res.string.ui_app_instance_detail_touch_start)
  map.put("ui_app_instance_edit_add_item_desc", Res.string.ui_app_instance_edit_add_item_desc)
  map.put("ui_app_instance_edit_app_name", Res.string.ui_app_instance_edit_app_name)
  map.put("ui_app_instance_edit_background", Res.string.ui_app_instance_edit_background)
  map.put("ui_app_instance_edit_bg_color", Res.string.ui_app_instance_edit_bg_color)
  map.put("ui_app_instance_edit_btn_pick", Res.string.ui_app_instance_edit_btn_pick)
  map.put("ui_app_instance_edit_change_image", Res.string.ui_app_instance_edit_change_image)
  map.put("ui_app_instance_edit_delete_desc", Res.string.ui_app_instance_edit_delete_desc)
  map.put("ui_app_instance_edit_game_bg_image", Res.string.ui_app_instance_edit_game_bg_image)
  map.put("ui_app_instance_edit_game_timeout", Res.string.ui_app_instance_edit_game_timeout)
  map.put("ui_app_instance_edit_general_config", Res.string.ui_app_instance_edit_general_config)
  map.put("ui_app_instance_edit_icon", Res.string.ui_app_instance_edit_icon)
  map.put("ui_app_instance_edit_items_icon_size", Res.string.ui_app_instance_edit_items_icon_size)
  map.put("ui_app_instance_edit_items_icon_y", Res.string.ui_app_instance_edit_items_icon_y)
  map.put("ui_app_instance_edit_items_text_size", Res.string.ui_app_instance_edit_items_text_size)
  map.put("ui_app_instance_edit_items_text_y", Res.string.ui_app_instance_edit_items_text_y)
  map.put("ui_app_instance_edit_label", Res.string.ui_app_instance_edit_label)
  map.put("ui_app_instance_edit_landscape", Res.string.ui_app_instance_edit_landscape)
  map.put("ui_app_instance_edit_marker_color", Res.string.ui_app_instance_edit_marker_color)
  map.put("ui_app_instance_edit_new_item_template", Res.string.ui_app_instance_edit_new_item_template)
  map.put("ui_app_instance_edit_new_wheel_game", Res.string.ui_app_instance_edit_new_wheel_game)
  map.put("ui_app_instance_edit_no_image", Res.string.ui_app_instance_edit_no_image)
  map.put("ui_app_instance_edit_none", Res.string.ui_app_instance_edit_none)
  map.put("ui_app_instance_edit_portrait", Res.string.ui_app_instance_edit_portrait)
  map.put("ui_app_instance_edit_result_timeout", Res.string.ui_app_instance_edit_result_timeout)
  map.put("ui_app_instance_edit_reward_visual", Res.string.ui_app_instance_edit_reward_visual)
  map.put("ui_app_instance_edit_rewards_count", Res.string.ui_app_instance_edit_rewards_count)
  map.put("ui_app_instance_edit_screen_orientation", Res.string.ui_app_instance_edit_screen_orientation)
  map.put("ui_app_instance_edit_select_image", Res.string.ui_app_instance_edit_select_image)
  map.put("ui_app_instance_edit_splash_image", Res.string.ui_app_instance_edit_splash_image)
  map.put("ui_app_instance_edit_splash_timeout", Res.string.ui_app_instance_edit_splash_timeout)
  map.put("ui_app_instance_edit_tab_preview", Res.string.ui_app_instance_edit_tab_preview)
  map.put("ui_app_instance_edit_text_color", Res.string.ui_app_instance_edit_text_color)
  map.put("ui_app_instance_edit_theme_design", Res.string.ui_app_instance_edit_theme_design)
  map.put("ui_app_instance_edit_timers_config", Res.string.ui_app_instance_edit_timers_config)
  map.put("ui_app_instance_edit_warn_min_sectors", Res.string.ui_app_instance_edit_warn_min_sectors)
  map.put("ui_app_instance_edit_warn_name_empty", Res.string.ui_app_instance_edit_warn_name_empty)
  map.put("ui_app_instance_edit_wheel_center_color", Res.string.ui_app_instance_edit_wheel_center_color)
  map.put("ui_app_instance_edit_wheel_center_scale", Res.string.ui_app_instance_edit_wheel_center_scale)
  map.put("ui_app_instance_edit_wheel_color", Res.string.ui_app_instance_edit_wheel_color)
}
